var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeychainApi } from '@api/keychain';
import { ThemeOpacity } from '@popup/theme.context';
let imgColors = {};
const componentToHex = (c) => {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
};
const rgbToHex = (r, g, b) => {
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
};
const getBackgroundColor = (src) => {
    var img = new Image();
    img.onerror = () => {
        img.onerror = null;
        img.src = '/assets/images/steem-engine.svg';
    };
    img.src = src;
    return getBackgroundColorFromImage(img);
};
const downloadColors = () => __awaiter(void 0, void 0, void 0, function* () {
    imgColors = yield KeychainApi.get('steem/tokensBackgroundColors');
});
const getBackgroundColorFromBackend = (symbol, theme) => {
    return imgColors ? imgColors[symbol] + ThemeOpacity[theme] : '00FFFFFF';
};
const getBackgroundColorFromImage = (img) => {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (!context)
        return '#0000002b';
    canvas.width = img.width;
    canvas.height = img.height;
    context === null || context === void 0 ? void 0 : context.drawImage(img, 0, 0, img.width, img.height);
    // Get the image data
    try {
        var imageData = context.getImageData(0, 0, img.width, img.height);
    }
    catch (err) {
        return '#0000002b';
    }
    var data = imageData.data;
    // Initialize variables
    var colorFrequency = {};
    var dominantColor = '';
    var maxFrequency = 0;
    // Loop through the image data
    for (var j = 0; j < data.length; j += 4) {
        var red = data[j];
        var green = data[j + 1];
        var blue = data[j + 2];
        if (red >= 200 && green >= 200 && blue >= 200)
            continue;
        // Convert the RGB values to a hex code
        var color = rgbToHex(red, green, blue);
        if (color === '#ffffff' || color === '#000000')
            continue;
        // Check if the color is already in the colorFrequency object
        if (colorFrequency[color]) {
            colorFrequency[color]++;
        }
        else {
            colorFrequency[color] = 1;
        }
    }
    // Get the dominant color from the color frequency object
    for (var color in colorFrequency) {
        if (colorFrequency[color] > maxFrequency) {
            maxFrequency = colorFrequency[color];
            dominantColor = color;
        }
    }
    return `${dominantColor}2b`;
};
export const ColorsUtils = {
    getBackgroundColor,
    getBackgroundColorFromImage,
    getBackgroundColorFromBackend,
    downloadColors,
};
